import { render, staticRenderFns } from "./PropertyDocuments.vue?vue&type=template&id=0727dd52&scoped=true"
import script from "./PropertyDocuments.vue?vue&type=script&lang=js"
export * from "./PropertyDocuments.vue?vue&type=script&lang=js"
import style0 from "./PropertyDocuments.vue?vue&type=style&index=0&id=0727dd52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0727dd52",
  null
  
)

export default component.exports